import PxoDateFilter                 from "../components/Filters/PxoDateFilter";
import PxoHorizonFilter              from "../components/Filters/PxoHorizonFilter";
import PxoCreateFormConteiner        from "../components/Form/PxoCreateFormConteiner";
import PxoSelectDemandModalConteiner from "../components/Modals/PxoSelectDemandModalContainer";
import PxoHiddenRowsModalContainer   from "../components/Modals/PxoHiddenRowsModalContainer";
import PxoContentSection             from "../components/Sections/PxoContentSection";
import PxoDemandSection              from "../components/Sections/PxoDemandSection";
import PxoEditDemandModalContainer   from "../components/Modals/PxoEditDemandModalContainer";


import { useUser        }            from '../contexts/UserContext'
import {  useEffect     }            from "react";
import { findPermission }            from '../utils/UserPermissionUtils'
import { useNavigate    }            from "react-router-dom";

function PxoPage() {
    
    const { userData }  = useUser()
    const navigate      = useNavigate();

    
    useEffect(() => {

        if (!userData?.permissions) return;
    
        const hasPermission = findPermission(userData, "Acesso à Pagina de PxO");
        
        if (!hasPermission) {
            navigate("/home");
        }
    
      }, [userData, navigate]);
    
    return (

        <div className="pg-content" >

            <h1 className="mb-5">
                Produtividade x Ociosidade
            </h1>

            <PxoEditDemandModalContainer/>

            <PxoHiddenRowsModalContainer />

            <PxoCreateFormConteiner />

            <PxoSelectDemandModalConteiner />

            <PxoDateFilter />

            <PxoHorizonFilter />
            
            <div className="flex flex-col gap-4">
                
                <PxoContentSection/>

                <PxoDemandSection/>
            
            </div>
              
        </div>
    )
}

export default PxoPage